import { Controller } from "@hotwired/stimulus"

// Controller for handling loading state when React filters change
export default class extends Controller {
  static get targets() {
    return ["loading", "content"]
  }

  showLoading() {
    if (this.hasLoadingTarget && this.hasContentTarget) {
      this.contentTarget.classList.add("d-none")
      this.loadingTarget.classList.remove("d-none")
    }
  }
}
